<template>
  <div>
    <b-modal id="modal-add-contact" @ok="handleOk" @show="clearData" :no-close-on-backdrop="true" :no-close-on-esc="true" :ok-only="true" cancel-variant="outline-secondary" header-bg-variant="primary" size="sm" ok-title="Add" centered title="Add Contact">
      <validation-observer ref="modalAddContact">
        <b-form>
          <b-form-group>
            <label for="userName">Select a Contact</label>
            <validation-provider name="User" #default="{ errors }" rules="required">
              <v-select id="userName" label="fullName" v-model="tempContact" :reduce="(val) => val" :options="contactProp" />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <b-form-group>
            <label for="contactRole">Role Name</label>
            <b-form-input id="contactRole" v-model="tempContactRole" />
          </b-form-group>
        </b-form>
      </validation-observer>
    </b-modal>
  </div>
</template>

<script>
import { BButton, BModal, VBModal, BForm, BFormInput, BFormGroup } from 'bootstrap-vue';
import vSelect from 'vue-select';
import Ripple from 'vue-ripple-directive';
import { ValidationProvider, ValidationObserver } from 'vee-validate';

export default {
  components: {
    BButton,
    BModal,
    BForm,
    BFormInput,
    BFormGroup,
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },

  props: {
    contactProp: Array,
  },

  data() {
    return {
      tempContact: null,
      tempContactRole: null,
      tempData: null,
    };
  },

  methods: {
    clearData() {
      this.tempContact = null;
      this.tempContactRole = null;
      this.tempData = null;
    },

    handleOk(bvModalEvent) {
      bvModalEvent.preventDefault();

      this.$refs.modalAddContact.validate().then((success) => {
        if (success) {
          this.tempData = {
            contactId: this.tempContact.id,
            contactTitle: this.tempContact.fullName,
            contactRole: this.tempContactRole,
            contactMail: this.tempContact.email,
            contactPhone: this.tempContact.phoneNumber,
          };

          this.$emit('postContactData', this.tempData);
          this.$bvModal.hide('modal-add-contact');
        }
      });
    },
  },
};
</script>
